class ModuleBasedComponentLoader {
    constructor(registerHandle) {
        this.loadComponent = (name, config, callback) => {
            if (!config.module) {
                callback(null);
                return;
            }
            requireReady(() => {
                require(["UI/Templates", "components/ComponentContextFactory", config.module], (tmpl, ccf, vm) => {
                    var tmplLoader = tmpl.default;
                    var promises = [tmplLoader.LoadTemplate(config.template)];
                    this.getCss(tmplLoader, promises, config);
                    $.when.apply($, promises)
                        .done(tmplHtml => {
                        callback({
                            template: ko.utils.parseHtmlFragment(tmplHtml),
                            createViewModel: (params, ci) => this.createViewModel(params, ci, vm, ccf.createContext)
                        });
                    });
                });
            });
        };
        this.createViewModel = (params, componentInfo, vm, ccf) => {
            let ctx = ko.contextFor(componentInfo.element);
            let parentContext = null;
            if (ctx.$component && ctx.$component._componentContext) {
                parentContext = ctx.$component._componentContext;
            }
            let componentContextData = ccf({
                instanceId: params.$instanceId || this.createInstanceId(),
                componentOrElement: componentInfo,
                parentContext: parentContext
            });
            if (componentInfo.element.querySelectorAll('slot').length > 0) {
                slot(componentInfo.templateNodes, componentInfo.element);
                removeSlots(componentInfo.templateNodes);
            }
            let componentViewModel = new vm.default((params && typeof params.$params != "undefined") ? params.$params : params, componentContextData);
            componentViewModel._componentContext = componentContextData;
            let originalDispose = componentViewModel.dispose;
            componentViewModel.dispose = componentContextData.events.dispose;
            if (originalDispose != null) {
                componentViewModel.dispose = () => {
                    componentContextData.events.dispose();
                    originalDispose();
                };
            }
            return componentViewModel;
        };
        this.register = (name, componentOptions) => {
            componentOptions = componentOptions || {};
            const path = componentOptions.path ? componentOptions.path + '/' + name : name;
            if (!componentOptions.module) {
                componentOptions.module = `components/${path}/module`;
            }
            if (!componentOptions.template) {
                if (!componentOptions.templateName) {
                    componentOptions.templateName = 'template.html';
                }
                componentOptions.template = `/scripts/requirejs/components/${path}/${componentOptions.templateName}`;
            }
            var cssUrls = [];
            if (componentOptions.css) {
                for (let cssName of Array.isArray(componentOptions.css) ? componentOptions.css : [componentOptions.css]) {
                    let theme = componentOptions.theme ? componentOptions.theme + '/' : '';
                    cssUrls.push(`/css/build/${theme}components/${path}/${cssName}.css`);
                }
                componentOptions.css = cssUrls;
            }
            this.registerHandle(name, {
                module: componentOptions.module,
                template: componentOptions.template,
                css: cssUrls
            });
        };
        this.registerHandle = registerHandle;
    }
    createInstanceId() {
        return 'a' + createGuid();
    }
    ;
    getCss(tmplLoader, promises, config) {
        if (config.css) {
            if (!Array.isArray(config.css))
                config.css = [config.css];
            ko.utils.arrayForEach(config.css, function (css) {
                promises.push(tmplLoader.LoadCSS(css));
            });
        }
    }
}
function isNode(target, name) {
    var nodeName = target && target.nodeName ? target.nodeName.toLowerCase() : '';
    return nodeName === name;
}
// Pluck dom node from given template
//
// @param {Array|String|Node} tpl
function pluckNodes(tpl) {
    if (Array.isArray(tpl)) {
        return tpl;
    }
    if (typeof tpl === 'string') {
        return ko.utils.parseHtmlFragment(tpl);
    }
    if (tpl.nodeType === Node.ELEMENT_NODE) {
        return [tpl];
    }
}
// Pluck slot node from given node list
//
// @param {Array} nodes
function pluckSlots(nodes) {
    var slots = [];
    ko.utils.arrayForEach(nodes, function (node) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
        }
        if (isNode(node, 'slot')) {
            slots.push(node);
        }
        else {
            ko.utils.arrayForEach(node.getElementsByTagName('slot'), function (slot) {
                slots.push(slot);
            });
        }
    });
    return slots;
}
// Pair slots according to name
//
// @param {Array} srcSlots
// @param {Array} destSlots
function matchSlots(srcSlots, destSlots) {
    var slotMaps = {};
    var slotPairs = [];
    var srcSlotsLen = srcSlots.length;
    ko.utils.arrayForEach(srcSlots.concat(destSlots), function (slot, i) {
        var slotName = slot.getAttribute('name');
        var slotMap = slotMaps[slotName] = slotMaps[slotName] || {
            src: null,
            dest: []
        };
        if (i < srcSlotsLen) {
            slotMap.src = slot;
        }
        else {
            slotMap.dest.push(slot);
        }
    });
    var slotNames = Object.keys(slotMaps);
    ko.utils.arrayForEach(slotNames, function (slotName) {
        var slotMap = slotMaps[slotName];
        if (!slotMap.src || !slotMap.dest.length) {
            return;
        }
        ko.utils.arrayForEach(slotMap.dest, function (destSlot) {
            slotPairs.push({
                name: slotName,
                src: slotMap.src,
                dest: destSlot
            });
        });
    });
    return slotPairs;
}
// Replace dest slot into source slot according to name
//
// @param {Array} srcSlots
// @param {Array} destSlots
function replaceSlot(srcSlot, destSlot) {
    if (srcSlot && destSlot) {
        var bindings = destSlot.getAttribute('data-bind');
        var clonedSrc = srcSlot.cloneNode(true);
        clonedSrc.setAttribute('data-bind', bindings);
        destSlot.parentNode.replaceChild(clonedSrc, destSlot);
    }
    else {
        srcSlot.parentNode.removeChild(srcSlot);
        destSlot.parentNode.removeChild(destSlot);
    }
}
function slot(srcTpl, destTpl) {
    var srcNodes = pluckNodes(srcTpl);
    var destNodes = pluckNodes(destTpl);
    var srcSlots = pluckSlots(srcNodes);
    var destSlots = pluckSlots(destNodes);
    var slotPairs = matchSlots(srcSlots, destSlots);
    ko.utils.arrayForEach(slotPairs, function (slotPair) {
        replaceSlot(slotPair.src, slotPair.dest);
    });
    return srcNodes;
}
function removeSlots(nodes) {
    nodes.forEach(node => {
        if (node.nodeType === Node.ELEMENT_NODE && isNode(node, 'slot'))
            nodes.splice(nodes.indexOf(node), 1);
    });
}
//# sourceMappingURL=module-based-component-loader.js.map